import React, { useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { get } from 'lodash';
import { compose } from 'utils/compose';
import { useParams } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import Footer from 'components/Footer/FooterContainer';

const PREFIX = 'Thankyou';

const classes = {
  root: `${PREFIX}-root`,
  heading: `${PREFIX}-heading`,
  text: `${PREFIX}-text`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')({
  [`& .${classes.root}`]: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  [`& .${classes.heading}`]: {
    color: '#2a2444',
  },
  [`& .${classes.text}`]: {
    color: '#5a5a5a',
  },
});

function Thankyou({ store }) {
  const { trackingCode } = useParams();
  const { deliveryStore } = store;
  const { settings, delivery } = deliveryStore;
  const client = get(delivery, 'client');

  useEffect(() => {
    if (settings && client) return;

    deliveryStore.getDelivery(trackingCode);
  }, [client, deliveryStore, settings, trackingCode]);

  return (
    <Root>
      <div className={classes.root}>
        <h2 className={classes.heading}>Thank you!</h2>
        <p className={classes.text}>Thank you for updating your delivery details!</p>
      </div>
      <Footer styles={{ position: 'absolute', bottom: 0, left: 0, right: 0 }} />
    </Root>
  );
}

export default compose(inject('store'), observer)(Thankyou);
